import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SeoScript from '@/components/base/SeoScript';
import HeroSection from './components/HeroSection';
import LatestUpdates from './components/LatestUpdates';
import CategoryShowcase from './components/CategoryShowcase';
import RankingSection from './components/RankingSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';

const webPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '韩漫画网 - 韩漫大全下拉式免费阅读',
  description: '韩漫画网提供海量韩漫大全下拉式免费阅读，无遮挡韩漫下拉式在线观看体验。加载迅速无干扰，专注享受漫画情节，支持热血、恋爱、奇幻、悬疑等全类型韩漫。',
  url: 'http://zzxcdell.com/',
  about: {
    '@type': 'Organization',
    name: '韩漫画网',
    url: 'http://zzxcdell.com/',
  },
};

export default function Home() {
  useEffect(() => {
    document.title = '韩漫画网 - 韩漫大全下拉式免费阅读 | 无遮挡韩漫下拉式在线';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', '韩漫画网提供海量韩漫大全下拉式免费阅读，无遮挡韩漫下拉式在线观看体验。加载迅速无干扰，专注享受漫画情节，支持热血、恋爱、奇幻、悬疑等全类型韩漫。');
    }
    const metaKw = document.querySelector('meta[name="keywords"]');
    if (metaKw) {
      metaKw.setAttribute('content', '韩漫,韩漫画网,韩漫大全,下拉式免费,无遮挡韩漫,韩漫在线阅读,韩国漫画');
    }
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', 'http://zzxcdell.com/');
    }
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <SeoScript data={webPageSchema} />
      <Navbar />
      <main>
        <HeroSection />
        <LatestUpdates />
        <CategoryShowcase />
        <RankingSection />
        <TestimonialSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}